// frontend/src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  tr: {
    common: require('./locales/tr/common.json')
  },
  en: {
    common: require('./locales/en/common.json')
  }
};

i18n
  .use(initReactI18next)
  .init({
    lng: 'en',
    fallbackLng: 'en',
    ns: ['common'],
    defaultNS: 'common',
    resources,
    interpolation: {
      escapeValue: false
    }
  });

export default i18n; // 👈 BU SATIR ŞART!
